// ======================================================================
// File Name       : SuperUserUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export function createServiceRoleDataOptions(roleList) {
  const data = [];
  if (roleList) {
    roleList.map((cur) => {
      const { superuserServiceRoleSecernId, superuserServiceRoleName } = cur;
      data.push({ name: superuserServiceRoleName, value: superuserServiceRoleSecernId });
    });
  }
  return data;
};

export function createEnterpriseRoleDataOptions(roleList) {
  const data = [];
  if (roleList) {
    roleList.map((cur) => {
      const { superuserEnterpriseRoleSecernId, superuserEnterpriseRoleName } = cur;
      data.push({ name: superuserEnterpriseRoleName, value: superuserEnterpriseRoleSecernId });
    });
  }
  return data;
};

// Step 10.2.0 START
export function createLoginAllServiceRelation(roleList) {
  const allServiceRelation = {};
  roleList.forEach((cur) => {
    const { superuserServiceRoleSecernId, serviceCd } = cur;
    allServiceRelation[serviceCd] = {
      serviceCd,
      superuserServiceRoleSecernId,
    };
  });
  return allServiceRelation;
}
// Step 10.2.0 END
